
export default function Footer() {
  return (
    <footer className="bg-green-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/c894575bb6e66422299273d3fa52e9c0.png" 
                  alt="Great Golf On The Go Logo" 
                  className="w-10 h-10 object-contain"
                />
              </div>
              <h3 className="text-xl font-bold">Great Golf On The Go</h3>
            </div>
            <p className="text-green-100 mb-4">
              Bringing the thrill of golf to your location with premium mobile simulator experiences across Florida.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/people/Greatgolfonthego/61579641355122/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 bg-green-700 rounded-full flex items-center justify-center cursor-pointer hover:bg-green-600"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a 
                href="https://www.instagram.com/greatgolfonthego?igsh=aG12NTRhcXVxbmow&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 bg-green-700 rounded-full flex items-center justify-center cursor-pointer hover:bg-green-600"
              >
                <i className="ri-instagram-fill text-sm"></i>
              </a>
              <a 
                href="https://youtube.com/@greatgolfonthego?si=FTrXNJI-2XB8FPWO" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 bg-green-700 rounded-full flex items-center justify-center cursor-pointer hover:bg-green-600"
              >
                <i className="ri-youtube-fill text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-green-100">
              <li>Corporate Events</li>
              <li>Fundraisers</li>
              <li>Birthday Parties</li>
              <li>Community Events</li>
              <li>Private Parties</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2 text-green-100">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line"></i>
                <span>904-657-4212</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line"></i>
                <span>greatgolfonthego@gmail.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line"></i>
                <span>Saint Johns County and Northeast Florida</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-green-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-green-100 text-sm">
              © 2025 Great Golf On The Go. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-green-100 hover:text-white text-sm cursor-pointer">
                Made with Readdy
              </a>
              <span className="text-green-100 text-sm cursor-pointer hover:text-white">Privacy Policy</span>
              <span className="text-green-100 text-sm cursor-pointer hover:text-white">Terms of Service</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
